import React from "react";
import Icon from "@ant-design/icons";

const TickSvg = ({ width = "1rem", height = "1rem", fill = "none" }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox={`0 0 ${width} ${height}`}
		height={height}
		width={width}
		fill={fill}
	>
		<path
			d="M3.74876 6.85954L2.30293 5.41371C2.22502 5.3358 2.11935 5.29203 2.00918 5.29203C1.899 5.29203 1.79333 5.3358 1.71543 5.41371C1.63752 5.49162 1.59375 5.59728 1.59375 5.70746C1.59375 5.76201 1.6045 5.81603 1.62537 5.86643C1.64625 5.91684 1.67685 5.96263 1.71543 6.00121L3.45709 7.74288C3.61959 7.90538 3.88209 7.90538 4.04459 7.74288L8.45293 3.33454C8.53083 3.25663 8.5746 3.15097 8.5746 3.04079C8.5746 2.93061 8.53083 2.82495 8.45293 2.74704C8.37502 2.66913 8.26935 2.62537 8.15918 2.62537C8.049 2.62537 7.94333 2.66913 7.86543 2.74704L3.74876 6.85954Z"
			fill="#F04438"
		/>
	</svg>
);
const TickIcon = (props) => <Icon component={() => <TickSvg {...props} />} />;

export default TickIcon;
